import { bindActionCreators } from "redux";
import { connect } from "react-redux";

// Actions
import updateDictionary from "./actions/updateDictionary";

const mapStateToProps = state => {
  return state;
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        updateDictionary
      },
      dispatch
    )
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
);



// WEBPACK FOOTER //
// ./src/apps/vocabularium/data/redux/connect.js